import { Pipe, PipeTransform } from '@angular/core';

import { pessoaTipos } from '../pessoa-tipo';

@Pipe({
    name: 'pessoaTipo'
})
export class PessoaTipoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = pessoaTipos.findIndex(pessoaTipo => pessoaTipo.id === value);
        if (index > -1) {
            return pessoaTipos[index].nome;
        }

        return 'CNPJ/CPF';
    }
}
